/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-concat */
/* eslint-disable react/prop-types */
import Draggable from "react-draggable";
import { Resizable } from "re-resizable";
import { useState, useEffect } from "react";
import useStore from "../../store";
import "./mac.scss";
import Close from "../icons/Close";
import Minimize from "../icons/Minimize";
import Stretch from "../icons/Stretch";

export default function MacBase(props) {
  const { setOnApp, setAppN } = useStore();
  const [width, setWidth] = useState("50%");
  const [height, setHeight] = useState("100%");

  const [max, setMax] = useState(true);

  useEffect(() => {
    setOnApp(true);
    setAppN(props.num);
  }, []);

  const handleMaxSize = () => {
    setWidth("100%");
    setHeight("100%");
    setCurrentPosition({ xRate: 0, yRate: 0 });
    setMax(false);
  };

  const handleScaleSize = () => {
    setWidth("50%");
    setHeight("70%");
    setCurrentPosition({
      xRate: window.innerWidth / 2 - (window.innerWidth * 25) / 100,
      yRate: 50
    });
    setMax(true);
  };

  const onDrag = (e, data) => {
    setCurrentPosition({ xRate: data.lastX, yRate: data.lastY });
  };

  const handleMinimize = () => {
    if (document.querySelector(".app-tray")) {
      const trayIcon = document.querySelector(".app-tray");
      trayIcon.classList.remove("bg-[#fcfcfc]");
    }
    document.querySelector(".react-draggable").classList.add("hidden");
  };
  const [currentPosition, setCurrentPosition] = useState({
    xRate: window.innerWidth / 2 - (window.innerWidth * 25) / 100,
    yRate: 50
  });

  return (
    <Draggable
      handle=".handle"
      position={{
        x: currentPosition.xRate,
        y: currentPosition.yRate
      }}
      defaultClassName={"z-[100000]"}
      onDrag={onDrag}
    >
      <Resizable
        defaultSize={{
          width: "100%",
          height: "97%"
        }}
        minWidth="400"
        minHeight="250"
        size={{ width, height }}
        onResizeStop={(d) => {
          setWidth(width + d.width);
          setHeight(height + d.height);
        }}
      >
        <div
          className="absolute inline-flex flex-col shadow-2xl w-full h-full resize wallpaper-menu wallp"
          id="wallpaper-menu"
        >
          <div
            className={
              "absolute bottom-0 right-0 " + "resizer-" + props.resizer
            }
          ></div>
          <div className="handle" id="wallpaper-handle">
            <div className="dots">
              <div
                className="dot red"
                onClick={() => {
                  setAppN(null);
                  props.appClose(false);
                  setOnApp(false);
                }}
              >
                <Close className="close" />
              </div>
              <div className="dot yellow" onClick={handleMinimize}>
                <Minimize className="minimize" />
              </div>
              <div
                className="dot green"
                onClick={() => {
                  max ? handleMaxSize() : handleScaleSize();
                }}
              >
                <Stretch className="stretch" />
              </div>
            </div>
            <strong>Facebook</strong>
            <div className="width-60 topBar"></div>
          </div>

          <div className="w-full flex-1">{props.children}</div>
        </div>
      </Resizable>
    </Draggable>
  );
}
